import React from 'react'

import { Col, Grid } from '../../../../packages/kiti/components/structure/Grid'
import { useForm, useFormState } from '../../../../packages/kiti/components/form/form/FormHandler'
import FormItem from '../../../../packages/kiti/components/form/form/FormItem'
import MinicrudSelect from '../../../../containers/minicruds/select/MinicrudSelect'
import ServiceOrderStatusSelect from '../../../../containers/statuses/select/ServiceOrderStatusSelect'
import Textarea from '../../../../packages/kiti/components/form/Textarea'

const GeneralSection = () => {
  const form = useForm()
  const { handleChange } = useFormState()

  return (
    <Grid direction="column" gap={0.5}>
      <Col>
        <FormItem label="Status" field="status" Input={ServiceOrderStatusSelect} manualStatusOnly />
      </Col>

      <Col>
        <FormItem
          label="Motivo"
          field="reason"
          Input={MinicrudSelect}
          entity={form.status?.name}
          disabled={!form.status?.id}
        />
      </Col>

      <Col>
        <FormItem label="Observações (opcional)" field="description" Input={Textarea} manualStatusOnly />
      </Col>
    </Grid>
  )
}

export default GeneralSection
